import React from "react";
import { Container, Link, List, ListItem, NoLink, SideBar, Txt, } from "./MemberSideBar.styles";
import { intersect } from "../routes";
import { useRouteMatch } from "react-router-dom";
export var MemberSideBar = function (_a) {
    var links = _a.links, userPermissions = _a.userPermissions;
    var url = useRouteMatch().url;
    var LinkList = function (links) {
        return links.map(function (link) {
            if (!link.path ||
                (link.permissions &&
                    !intersect(userPermissions, link.permissions).length)) {
                return (React.createElement(NoLink, { key: link.name },
                    React.createElement(ListItem, null,
                        React.createElement(Txt, null, link.name))));
            }
            return (React.createElement(Link, { to: url + "/" + link.path, key: link.name, activeClassName: "selected" },
                React.createElement(ListItem, null,
                    React.createElement(Txt, null, link.name))));
        });
    };
    return (React.createElement(Container, null,
        React.createElement(SideBar, null,
            React.createElement(List, null, LinkList(links)))));
};
//# sourceMappingURL=MemberSideBar.js.map